(function() {
  'use strict';
  angular.module('dnSecurity')
  .controller('secUserToolsController', ['secSecurityService', '$state', '$transitions', '$rootScope',
    function(securityService, $state, $transitions, $rootScope){
      var vm = this;
      function getAutentication() {
        securityService.getLoggedInUser().then((authentication) => {
          vm.authentication = authentication;
        });
      }
      getAutentication();
      $rootScope.$on('authenticationChanged', function() {
        getAutentication();
      });
      vm.logout = () => {
        securityService.logout().then(() => {
          $rootScope.$broadcast('authenticationChanged', {loggedIn: false, loggedOut: true});
        });
        (function(t,e,s,o){var n,c,l;t.SMCX=t.SMCX||[],e.getElementById(o)||(n=e.getElementsByTagName(s),c=n[n.length-1],l=e.createElement(s),l.type="text/javascript",l.async=!0,l.id=o,l.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd2nzeDxlOW4YcvSNTsyguHIMKJWBVZAUQH4bQ9Ecv_2BEF.js"].join(""),c.parentNode.insertBefore(l,c))})(window,document,"script","smcx-sdk");
      };
      vm.exitUserView = () => {
        securityService.exitSwitchUser().then(() => {
          $rootScope.$broadcast('authenticationChanged', {loggedIn: true});
        });
      };
  }]);
})();
